// extracted by mini-css-extract-plugin
export var currentCustomer = "header-module--currentCustomer--2Jl4U";